module.exports = __webpack_public_path__ + "img/jeffrey-pro.0057f7a8.jpg";